var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"search-listing"},[(_vm.$isMobile())?_c('assistant-list-mobile',{attrs:{"filters":_vm.filters}}):_c('div',[_c('assistant-list',{attrs:{"filters":_vm.filters}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }